import script from "./DetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./DetailPage.vue?vue&type=style&index=0&id=1fd55c2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd55c2c"]])

export default __exports__